<template lang="pug">
v-card
  v-card-title
    .d-flex.justify-space-between.align-center.w-100
      span Margen bruto por producto y cliente
      v-select.month-select(v-model="monthFilter" :items="monthOptions" label="Filtrar por mes" outlined clearable hide-details)
  v-card-text
    v-skeleton-loader(v-if="!tableData" type="table-heading, table-row-divider@6")
    v-simple-table.mix-table(v-else fixed-header height="420")
      template(v-slot:default)
        thead
          tr
            th Producto
            th Unidad de medida
            th.text-right Utilidad Total
            th.text-right(v-for="names in tableData.customers_name") {{names}}
        tbody
          tr(v-for="(item, i) in rows" :key="i")
            td.td {{item.product_name}}
            td.td {{item.product_unit}}
            td.td.text-right {{item.total_profit | moneyMM}}
            td.td.text-right(v-for="quantity in item.quantity_by_customer") {{quantity | number}}
          tr.totals-row(v-if="rows.length")
            td.td Total
            td.td
            td.td.text-right {{totals.profit | moneyMM}}
            td.td.text-right(v-for="(q, ci) in totals.byCustomer" :key="'t'+ci") {{q | number}}
    v-pagination(v-model="pagination.page" :length="total_pages" @input="fetchData")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    },
    projection: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        page_size: 100,
      },
      product_count: 0,
      tableData: null,
      monthFilter: null,
    }
  },
  methods: {
    ...mapActions('commercial_projection', ['getOptimalMixTable']),
    async fetchData() {
      const params = {
        ...this.filters,
        ...this.pagination,
        ...(this.monthFilter !== null && { month: this.monthFilter }),
        projection: this.projection || this.$route.params.id
      }
      const { data, error } = await this.getOptimalMixTable(params)
      if (!error) {
        this.tableData = data
        this.product_count = data.count
        const totalProfit = data?.data?.reduce((acc, cur) => acc + cur.total_profit, 0)
        this.$emit('setTotalYearProfit', totalProfit)
      }
    }
  },
  computed: {
    // Solo filas con producto y utilidad > 0 (elimina las filas "$0" que ensucian)
    rows() {
      if (!this.tableData || !this.tableData.data) return []
      return this.tableData.data.filter(item => item.product_name && item.total_profit > 0)
    },
    totals() {
      const byCustomer = (this.tableData && this.tableData.customers_name || []).map(() => 0)
      let profit = 0
      this.rows.forEach(item => {
        profit += item.total_profit || 0
        ;(item.quantity_by_customer || []).forEach((q, i) => { byCustomer[i] += (q || 0) })
      })
      return { profit, byCustomer }
    },
    total_pages() {
      return Math.ceil(this.product_count / this.pagination.page_size)
    },
    monthOptions() {
      return [
        { text: 'Enero', value: 0 },
        { text: 'Febrero', value: 1 },
        { text: 'Marzo', value: 2 },
        { text: 'Abril', value: 3 },
        { text: 'Mayo', value: 4 },
        { text: 'Junio', value: 5 },
        { text: 'Julio', value: 6 },
        { text: 'Agosto', value: 7 },
        { text: 'Septiembre', value: 8 },
        { text: 'Octubre', value: 9 },
        { text: 'Noviembre', value: 10 },
        { text: 'Diciembre', value: 11 },
      ]
    },
  },
  watch: {
    filters: {
      handler() {
        this.pagination.page = 1
        this.fetchData()
      },
      deep: true,
    },
    monthFilter() {
      this.pagination.page = 1
      this.fetchData()
    },
  },
  created() {
    this.fetchData()
  }
}
</script>

<style scoped>
.td {
  min-height: 32px !important;
  height: 32px !important;
}

.month-select {
  flex-grow: 0;
  width: 300px;
}

.mix-table >>> td.text-right, .mix-table >>> th.text-right { text-align: right !important; font-variant-numeric: tabular-nums; }
.mix-table >>> .totals-row td { font-weight: 700; border-top: 2px solid #ECEDF0; background: #FAFAFB; }
</style>
